import { render } from "./blank-layout.vue?vue&type=template&id=525050bf"
const script = {}
script.render = render

export default script